// ImageCache.js
// This is just a plain object, no React hooks.
const imageCache = {};

export function getCachedImage(url) {
  return imageCache[url];
}

export function storeCachedImage(url, img) {
  imageCache[url] = img;
}
